"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityModalUpdateFormRoute = exports.EntityUpdateFormDefaultProps = exports.EntityModalCreateFormRoute = exports.EntityModalFormRoute = exports.EntityFormDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var router_1 = require("@reach/router");
var styled_components_1 = __importStar(require("styled-components"));
var deepmerge_1 = __importDefault(require("deepmerge"));
var theme_1 = require("@shapeable/theme");
var lodash_1 = require("lodash");
var sprintf_js_1 = require("sprintf-js");
var client_1 = require("@apollo/client");
var use_entity_update_query_1 = require("../../hooks/use-entity-update-query");
var use_lang_1 = require("../../hooks/use-lang");
var use_entity_state_1 = require("../../hooks/use-entity-state");
var route_return_path_1 = require("../../utils/route-return-path");
var get_graphql_error_1 = require("../../utils/get-graphql-error");
var use_statuses_1 = require("../../hooks/use-statuses");
var use_entities_1 = require("../../hooks/use-entities");
var use_icons_1 = require("../../hooks/use-icons");
var entity_form_layout_1 = require("./entity-form-layout");
var modal_1 = require("../elements/modal");
var icon_button_1 = require("../elements/icon-button");
var error_dialog_layout_1 = require("../elements/error-dialog-layout");
var entity_delete_dialog_1 = require("./entity-delete-dialog");
var entity_duplicate_dialog_1 = require("./entity-duplicate-dialog");
var form_context_1 = require("../context/form-context");
var react_draggable_1 = __importDefault(require("react-draggable"));
var useState = React.useState;
exports.EntityFormDefaultProps = {
  loading: false,
  metadata: {}
};
// -------- Styles -------->
var ModalStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n    box-shadow: 0 3px 5px -1px rgba(0,0,0,0.7);\n    position: relative;\n    max-width: 100vw;\n    z-index: 100;\n  "], ["\n    width: 100%;\n    box-shadow: 0 3px 5px -1px rgba(0,0,0,0.7);\n    position: relative;\n    max-width: 100vw;\n    z-index: 100;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    height: auto;\n    ", "\n  "], ["\n    height: auto;\n    ", "\n  "])), function (props) {
    return props._maxWidth && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      max-width: ", ";\n    "], ["\n      max-width: ", ";\n    "])), props._maxWidth);
  })
});
var DuplicateDialogStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Modal: (0, styled_components_1.default)(modal_1.Modal)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ModalStyles),
  DuplicateDialog: (0, styled_components_1.default)(entity_duplicate_dialog_1.EntityDuplicateDialog)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), DuplicateDialogStyles)
};
/**
 * A component which handles the common aspects of logic in both an update and create form
 * presenting it in a specified form layout component.
 */
var EntityModalFormRoute = function (props) {
  var mutationResult = props.mutationResult,
    definition = props.definition,
    className = props.className,
    id = props.id,
    loading = props.loading,
    error = props.error,
    entityData = props.entityData,
    metadata = props.metadata;
  if (!definition) {
    throw new Error('This form could not be created due to invalid entity configuration.');
  }
  var _a = definition.create,
    create = _a === void 0 ? {} : _a,
    _b = definition.update,
    update = _b === void 0 ? {} : _b,
    form = definition.form,
    name = definition.name,
    components = definition.components,
    routes = definition.routes;
  var isCreate = !Boolean(id);
  var queryName = isCreate ? definition.create.mutationFieldName : definition.update.mutationFieldName;
  var t = (0, use_lang_1.useLang)();
  var icons = (0, use_icons_1.useIcons)();
  var paramState = props['*'];
  var _c = __read((0, client_1.useMutation)(props.definition.delete.mutation, {
      onError: function (error) {
        throw new Error(error.message);
      }
    }), 1),
    deleteMutation = _c[0];
  var _d = __read((0, client_1.useLazyQuery)(props.definition.namedQuery), 2),
    entityNamed = _d[0],
    _e = _d[1],
    nameCheckLoading = _e.loading,
    nameCheckData = _e.data;
  var modal = form.modal;
  var modalMaxWidth = modal.maxWidth,
    fill = modal.fill;
  var labelKey = isCreate ? create.label : update.label;
  var statusInfo = (0, use_statuses_1.useStatuses)();
  var entities = (0, use_entities_1.useEntities)();
  var PUBLISHED = statusInfo.PUBLISHED;
  var initialStateContext = {
    statusInfo: statusInfo,
    entities: entities,
    isModal: true
  };
  var initialFieldState = isCreate ? props.initialFieldState || definition.create.initialState(initialStateContext) : props.initialFieldState;
  // set a default publish status
  if (definition.usePublishStatus && isCreate && initialFieldState.publishStatus === undefined) {
    initialFieldState.publishStatus = {
      value: PUBLISHED
    };
  }
  var _f = __read(useState(initialFieldState), 2),
    fieldState = _f[0],
    setFieldState = _f[1];
  var _g = __read((0, use_entity_state_1.useEntityState)(definition.aliasOf, 'form'), 4),
    formState = _g[0],
    setFormState = _g[1],
    resetFormState = _g[2],
    patchFormState = _g[3];
  var _h = __read(useState(entityData), 2),
    patchedEntityData = _h[0],
    setPatchedEntityData = _h[1];
  var apolloClient = (0, client_1.useApolloClient)();
  React.useEffect(function () {
    setPatchedEntityData(entityData);
  }, [entityData]);
  var returnPath = (0, route_return_path_1.routeReturnPath)(props['*']);
  var patchEntityData = function (patch, callback) {
    setPatchedEntityData((0, deepmerge_1.default)(patchedEntityData, patch));
    if (callback) {
      callback();
    }
  };
  var showModal = function (component, entityTypeName) {
    patchFormState({
      activeModal: component,
      childEntityTypeName: entityTypeName
    });
  };
  var hideModal = function () {
    patchFormState({
      activeModal: null,
      childEntityTypeName: null
    });
  };
  var handleCancel = props.onCancel || function () {
    return hideModal();
  };
  var handleSubmit = props.onSubmit ? function (entity) {
    props.onSubmit(entity);
  } : function (entity) {
    var slug = entity.slug;
    var to = slug && definition.routes.details && definition.to(slug, '');
    if (returnPath) {
      (0, router_1.navigate)(returnPath);
    } else {
      (0, router_1.navigate)(to || definition.toList());
    }
  };
  // use the specified form layout, or fallback to a generic layout
  var Layout = components && components.form || entity_form_layout_1.EntityFormLayout;
  React.useEffect(function () {
    setFieldState(initialFieldState || {});
    setFormState(definition.form.initialState);
  }, [loading]);
  var onChange = function (fieldState) {
    setFieldState(fieldState);
  };
  var onCancel = function () {
    setFormState(definition.form.initialState);
    setFieldState(initialFieldState || {});
    handleCancel();
  };
  var activeModal = formState.activeModal;
  var onSubmit = function (_a) {
    return __awaiter(void 0, [_a], void 0, function (_b) {
      var input, fieldMetadata, _c, mutation, loading, result, err_1;
      var mutationInput = _b.mutationInput,
        fieldState = _b.fieldState;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            return [4 /*yield*/, form.transformInput({
              input: mutationInput,
              metadata: metadata,
              client: apolloClient
            })];
          case 1:
            input = _d.sent();
            fieldMetadata = (0, lodash_1.pickBy)((0, lodash_1.mapValues)(fieldState, function (value, key) {
              return value === null || value === void 0 ? void 0 : value.metadata;
            }));
            _c = __read(mutationResult, 2), mutation = _c[0], loading = _c[1].loading;
            _d.label = 2;
          case 2:
            _d.trys.push([2, 4,, 5]);
            return [4 /*yield*/, mutation({
              variables: {
                id: id,
                input: __assign(__assign({}, (0, lodash_1.omit)(input, 'createdBy', 'updatedBy', 'created', 'updated', 'isDeletable', 'slug')), {
                  metadata: __assign(__assign({}, (0, lodash_1.pick)(metadata, 'parent', 'name', 'index')), {
                    fieldData: JSON.stringify(fieldMetadata)
                  })
                })
              }
            })];
          case 3:
            result = _d.sent();
            if (result && !loading) {
              handleSubmit((0, lodash_1.get)(result.data, queryName, {}));
            }
            return [3 /*break*/, 5];
          case 4:
            err_1 = _d.sent();
            patchFormState({
              error: (0, get_graphql_error_1.getGraphQlError)(err_1.message, {
                entities: entities,
                t: t,
                icons: icons
              })
            });
            return [3 /*break*/, 5];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  };
  var showDuplicateDialog = function (name, items) {
    if (items === void 0) {
      items = [];
    }
    showModal(React.createElement(My.DuplicateDialog, {
      entityTypeName: definition.name,
      items: items,
      name: name,
      onContinue: function () {
        return hideModal();
      },
      onCancel: onCancel
    }));
  };
  var onDuplicatesFound = function (items) {
    if (items === void 0) {
      items = [];
    }
    return showDuplicateDialog((0, lodash_1.get)(fieldState, 'name.value'), items);
  };
  var onDelete = function () {
    showModal(React.createElement(entity_delete_dialog_1.EntityDeleteDialog, {
      entity: entityData,
      mutation: deleteMutation,
      onCancel: function () {
        return hideModal();
      },
      onComplete: function (result) {
        (0, router_1.navigate)(definition.toList());
      }
    }));
  };
  var checkForDuplicates = function (name) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (!!(0, lodash_1.trim)(name)) {
          entityNamed({
            variables: {
              name: name
            }
          });
        }
        return [2 /*return*/];
      });
    });
  };
  var onNameBlur = function (name) {
    var _a;
    if (isCreate && definition.useDuplicateCheck) {
      checkForDuplicates(name);
    }
    if (definition.useSiteSlug && !(0, lodash_1.trim)(((_a = fieldState === null || fieldState === void 0 ? void 0 : fieldState.siteSlug) === null || _a === void 0 ? void 0 : _a.value) || '')) {
      var siteSlug = (0, lodash_1.kebabCase)(name);
      setFieldState(__assign(__assign({}, fieldState), {
        siteSlug: {
          value: siteSlug
        }
      }));
    }
  };
  // listen out for entity duplicate checks
  React.useEffect(function () {
    if (nameCheckData) {
      var items = nameCheckData["".concat(definition.leadingPluralTypeName, "Named")];
      if (items && items.length) {
        onDuplicatesFound(items);
      }
    }
  }, [nameCheckLoading, nameCheckData]);
  var mainLabel = (0, sprintf_js_1.sprintf)(t(labelKey), definition.label);
  var containerRef = React.useRef();
  var label = mainLabel;
  var layout = React.createElement(React.Fragment, null, activeModal && React.createElement(My.Modal, {
    showCloseButton: false
  }, activeModal), React.createElement(form_context_1.FormProvider, {
    value: {
      showModal: showModal,
      hideModal: hideModal,
      patchEntityData: patchEntityData
    }
  }, React.createElement(Layout, {
    paramState: paramState,
    isModal: true,
    sourceEntity: props.sourceEntity,
    fillModal: fill,
    metadata: metadata,
    entityData: patchedEntityData,
    loading: loading,
    formState: formState,
    fieldState: fieldState,
    isCreate: isCreate,
    entityTypeName: definition.name,
    label: label,
    showModal: showModal,
    hideModal: hideModal,
    patchEntityData: patchEntityData,
    onCancel: onCancel,
    onSubmit: onSubmit,
    onChange: onChange,
    onNameBlur: onNameBlur,
    onDelete: onDelete
  })));
  return React.createElement(react_draggable_1.default, {
    handle: ".handle"
  }, React.createElement(My.Container, {
    ref: containerRef,
    _maxWidth: modalMaxWidth,
    unbounded: true,
    className: className
  }, layout));
};
exports.EntityModalFormRoute = EntityModalFormRoute;
exports.EntityModalFormRoute.defaultProps = exports.EntityFormDefaultProps;
var EntityModalCreateFormRoute = function (props) {
  var mutationResult = (0, client_1.useMutation)(props.definition.create.mutation, {
    onError: function (error) {
      throw new Error(error.message);
    }
  });
  return React.createElement(exports.EntityModalFormRoute, __assign({
    mutationResult: mutationResult
  }, props));
};
exports.EntityModalCreateFormRoute = EntityModalCreateFormRoute;
exports.EntityUpdateFormDefaultProps = __assign(__assign({}, exports.EntityFormDefaultProps), {
  loading: false
});
var EntityModalUpdateFormRoute = function (props) {
  var id = props.id,
    definition = props.definition,
    fillModal = props.fillModal,
    sourceEntity = props.sourceEntity,
    rest = __rest(props, ["id", "definition", "fillModal", "sourceEntity"]);
  if (!definition) {
    throw new Error('This form could not be created due to invalid entity configuration.');
  }
  var icons = (0, use_icons_1.useIcons)();
  var t = (0, use_lang_1.useLang)();
  // Loads the entity record we're actually updating
  var name = definition.name,
    aliasOf = definition.aliasOf,
    _a = definition.form,
    form = _a === void 0 ? {} : _a,
    _b = definition.update,
    update = _b === void 0 ? {} : _b,
    routes = definition.routes;
  var query = update.query;
  var _c = (0, use_entity_update_query_1.useEntityUpdateQuery)(aliasOf, query, {
      variables: {
        id: id
      },
      valueKeys: update.valueKeys
    }),
    data = _c.data,
    loading = _c.loading,
    error = _c.error,
    entityData = _c.entityData;
  var mutationResult = (0, client_1.useMutation)(props.definition.update.mutation, {
    onError: function (error) {
      throw new Error(error.message);
    }
  });
  var button = React.createElement(icon_button_1.IconButton, {
    to: '/',
    icon: React.createElement(icons.ChevronLeftCircle, null)
  }, t((0, sprintf_js_1.sprintf)('Return to Home Page', definition.pluralLabel)));
  if (error) {
    console.log(error);
    return React.createElement(error_dialog_layout_1.ErrorDialogLayout, {
      action: "update",
      definition: definition,
      button: button,
      error: error
    });
  }
  return React.createElement(exports.EntityModalFormRoute, __assign({
    fillModal: fillModal,
    id: id,
    sourceEntity: sourceEntity,
    definition: definition,
    mutationResult: mutationResult,
    initialFieldState: data,
    entityData: entityData,
    loading: loading
  }, rest));
};
exports.EntityModalUpdateFormRoute = EntityModalUpdateFormRoute;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;